import { profilingApi } from '@/model/profiling/api.generated';

export function registerProfilingTags(): void {
  profilingApi.enhanceEndpoints({
    endpoints: {
      getApiProjectsByProjectIdTablesAndTableNameProfile: {
        providesTags: (_result, _error, arg) => [{ type: 'tables', id: arg.tableName }],
      },
    },
  });
}
